// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"3936ca39","578":"bfeb439f"}[chunkId] + ".chunk.css";
};